import React, { Component } from 'react';
import queryString from 'query-string';
import {TextField} from '@betareader/design-system';

// redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// i18n
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';

const searchTimeoutDelay = 1000;

export class DiscoverSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: ''
    };
  }

  componentDidMount() {
    const { location } = this.props;
    const query = queryString.parse(location.search);
    const { search } = query;
    this.setState({
      searchTerm: search || ''
    });
  }

  componentWillUnmount() {
    clearTimeout(this.searchTimeout);
  }

  handleSearchChange = (event) => {
    this.setState({
      searchTerm: event.target.value
    }, () => {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(this.triggerSearch, searchTimeoutDelay);
    });
  }

  handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      clearTimeout(this.searchTimeout);
      this.triggerSearch();
    }
  }

  triggerSearch = () => {
    const { searchTerm } = this.state;
    const { location, history } = this.props;
    const query = queryString.parse(location.search);
    query.search = searchTerm;
    history.replace(`${location.pathname}?${queryString.stringify(query)}`);
  };

  render() {
    const { searchTerm } = this.state;
    const { t, loadingFeedback } = this.props;

    return (
      <TextField
        id="feedback-search"
        label={t('FeedbackSearch')}
        type="search"
        value={searchTerm}
        aria-busy={loadingFeedback ? 'true' : 'false'}
        placeholder={t('FeedbackSearch')}
        onChange={this.handleSearchChange}
        onKeyDown={this.handleKeyDown}
      />
    );
  }
}

// redux stuff
const mapStateToProps = state => ({
  loadingFeedback: state.comment.loadingFeedback
});

const mapDispatchToProps = dispatch => bindActionCreators({
}, dispatch);

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(DiscoverSearch)));
